<template>
<v-menu
                  v-model="showMenu"
                 :close-on-click="false" :disabled="hideSelect"
                  :close-on-content-click="true"
                  :offset-y="true"
                  :nudge-bottom="0" bottom allow-overflow
                >
      <template v-slot:activator="{ on, attrs }">
    <v-toolbar flat :height="height" v-bind="$attrs">
     
      <slot name="icon" v-if="searchType!=='zipcode' || !$vuetify.breakpoint.mobile"></slot>
      <character-input v-model="zipcode" v-show="searchType=='zipcode'"
                :mask="['*','*','*','*','#','#']" ref="zipcode"
                :deviders="[,,,'-',]"
                :autofocus="true" style="width:99%!important;max-width:300px"
                :size="6" @finish="finishZip"></character-input>
      <v-text-field v-show="searchType=='search'" style="width:99%"
              :prepend-icon="$attrs.icon" class="font-italic"
                  ref="selector"
                  v-model="search"
                  flat
                   v-bind="attrs"
                          v-on="on"
                  hide-details :autofocus="autofocus"
                  :placeholder="placeholder"
                  @focus="$event.target.select()"
               >
                </v-text-field>
                
                 <v-text-field v-if="searchType=='zipcode' || showNumber" style="width:60px;max-width:100px;"
                  ref="number"
                  v-model.number="number" class="ml-2"
                  type="number"
                  flat outlined
                  dense hide-details
                  placeholder="Nr" :autofocus="searchType!=='zipcode'"
                  @focus="$event.target.select()"
                       
                >
                </v-text-field>
                  <!--v-progress-circular v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-circular-->
                  <v-btn icon @click="resetMe" v-if="search || searchType=='zipcode'"><v-icon>close</v-icon></v-btn>
                   <v-btn text color="primary" v-if="showCurrent" @click="getCurrentLocation" ><v-icon left :large="!largeScreen">pin_drop</v-icon>
                    <span v-if="largeScreen">Gebruik mijn locatie</span></v-btn>
                     <v-progress-linear v-if="loading"
                     style="position: absolute;margin-top: 67px;margin-left: -18px;"
                    indeterminate
                    color="primary" striped
                  ></v-progress-linear>
     </v-toolbar>
     </template>
     
                  <v-list v-if="results.length>0">
                    
                    <template  v-for="(item, index) in results">
                     <address-item :hide-icon="true"
                        :key="index"
                        :value="item"
                       
                        @valid="select"
                        @select="selectAddress"
                      > 
                      </address-item>
                      <v-divider :key="'t' + index" v-if="index<results.length-1"></v-divider>
                    </template>
                  <v-list-item class="px-5 grey--text" v-if="results.length==0 && errorMessage" v-text="errorMessage"></v-list-item>
                  </v-list>
                  
                </v-menu>
</template>
<script>

import CharacterInput from "@/components/CharacterInput.vue";
import AddressItem from "@/components/address/AddressItem.vue";
import locationService from '@/modules/locationService'
export default {
  mixins: [locationService],
  props: ['placeholder','type',"value", 'showSwitch','height', 'showCurrent', 'hideSelect', 'autofocus' ],
  components: {
    CharacterInput,
    AddressItem
  },
  data: () => ({
    loading: false,
    zipcode: null,
    number: null,
    search: null,
    errorMessage: null,
    timer: null,
    timeout: 1000,
    selected: null,
    searchType: 'zipcode',
    list:[],
    showNumber: false
  }),

  computed: {
    showMenu:{
      get(){
        return this.list.length>0
      },
      set(value){

      }
    },
    address:{
      get(){
        return this.value
      },
      set(value){
        this.$emit('input',value)
      }
    },
    results(){
        let list = this.list.filter(l=>
            (l.number || !this.number ) && 
            (l.number==this.number 
            || (!this.number && !l.number) 
            || l.name == this.search))
       if (list.length == 0) list = [this.list[0]]
       return list
    },
   name (){
        return this.getName(this.address)
        
      },
   isValid(){
          if (!this.address) return false
          if (!this.address.name) return false
          if (!this.address.zipcode) return false
          if (!this.address.number) return false
          if (!this.address.coordinate) return false
          return true
      },
  },
mounted(){
    this.searchType = this.type || 'zipcode'
},
  watch: {
    value(val){
        this.address = val
        if (!val) return false
        this.address.name = this.name
        this.search = this.name
    },
    search(val) {
      if (!val) return this.resetMe()
      if (this.searchType !== 'zipcode'){
      var thenum = val
      thenum = thenum.replace( /^\D+/g, '');
      if (thenum) {
        this.number = thenum
        this.showNumber
      }
      }
      this.doSearch(val)
    },
    zipcode(val){
      //if (!val) this.search =null
      //this.search = val
    },
    type(){
       this.searchType = this.type || 'zipcode'
    },
    number(val){
      if (!val) return false
      if (this.searchType == 'zipcode') {
        this.search = this.zipcode + ' ' + val
      }else if (this.address) {
        this.address.number = val
        this.doSearch(this.getName(this.address))//this.address.number = val
        //this.search += val//this.getName(this.address)
      }
    }
  },
  methods: {
    getName(address){
      if (!address) return null
      return [address.street,address.number ,address.addition,",",address.city].filter(a=>a!=undefined).join(' ').replace(' , ',', ')
    },
     resetMe() {
      this.setList([])
      this.search = null;
      this.zipcode = null;
      //this.showNumber = false
      this.number = null
      this.errorMessage = null
      this.searchType = 'search'
      this.$emit('cancel')
      this.$emit('search',null)
      this.$emit('result',null)
      this.setList([])
      if (this.searchType!='zipcode' && this.$refs[this.searchType] && this.autofocus) this.focus()
    },
    async getCurrentLocation(){
        let address = await this.getLocation()
        if (!address) return alert('Zet je locatie aan om deze functie te gebruiken')
        this.selectAddress(address)
    },
    focus(value){
      if (this.$refs[this.searchType] && this.$refs[this.searchType].focus) this.$refs[this.searchType].focus()
    },
    finishZip(){
      this.$refs.number.focus()
      this.showNumber=true;
      //this.searchType = 'search'
      //this.search = this.zipcode.replace(' ','')
    },
    setNumber(address){
        this.loading = true;
        this.searchType = 'search'
        this.address = address
        this.address.name = this.name
        this.search = this.address.name = this.name
        this.showNumber = true
        
        this.$nextTick(()=>{
          this.loading = false
        })
        //let pos = this.name.indexOf(',')
        //console.log(this.search, pos,this.$refs.select.$el.getElementsByTagName('INPUT')[0])
        //this.$refs.select.$el.getElementsByTagName('INPUT')[0].select()
    },
    setList(list){
        this.list = list
        this.$emit('result',this.results)
    },
    doSearch(search){
      if (this.timer) clearTimeout(this.timer);
      if (this.showNumber && !this.number) return;
      if (this.loading || !search || search.length < 6 ) return;
      if (this.searchType=='zipcode' && !this.number) return false
      //let search = val + (this.number ? ' ' + this.number : '')
      this.timer = setTimeout(() => {
        this.getlist(search)
        this.$emit('search',search)
      }
        , this.timeout);
      
    },
    selectAddress(address){
        this.address = address
        this.setList([])
        this.showNumber = address.number? false : true
    },
    async getlist(search) {
      this.loading = true;
      this.errorMessage = "";
      let response = await this.$http.post(
        `/api/services/address/search`, {search}
      );
      if (response.data.result == "OK") this.setList(response.data.list)
      if (response.data.result == "ERROR") {
        this.errorMessage = response.data.message;
        this.setList([])
      }
      
      if (!this.hideSelect) this.$emit('result',this.results)
      this.loading = false;
      this.$nextTick(()=>{
        if (this.$refs.select) this.$refs.select.isMenuActive = true
      })
    },
    select(address){
      this.showNumber = false
      this.address = address
      // this.address.name = this.name
             this.$emit('select', address)
        this.search = null
       this.setList([])
        this.zipcode = null;
      //this.showNumber = false
      this.number = null
    },
  },
};

function setCaretPosition(elem, caretPos) {
     if(elem != null) {
        if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}
</script>
